// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N5IM","largestCol":"styles_largestCol__2vUm2","smallestCol":"styles_smallestCol__2mm7r"};